export const ERROR_FIELD_INVALID = 'FIELD_INVALID'
export const VERSION_NOT_MATCH = 'VERSION_NOT_MATCH'
export const URL_REGEX = new RegExp(
  '(^https?:\\/\\/)((www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*))',
  'g'
)
export const extractDomainFromUrl = (url: string) => {
  if (url.match(URL_REGEX)) {
    const match = URL_REGEX.exec(url)
    return match ? match[2].toLowerCase() : ''
  }
  return ''
}

export const FORMAT_DATE = 'DD-MM-yyyy HH:mm'

export const FORMATE_DATE_NO_HOURS = 'DD/MM/yyyy'

export const FORMAT_DATETIME = 'DD-MM-yyyy HH:mm:ss'

/**
 * Shared so the onboarding form and the alert recipient editor agree on what an address is.
 */
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
